import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { css } from "styled-components";

actionStyles.removeSelectedButton = {
        typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
        },
        css: css`
            padding: 0 15px;
            margin-right: 10px;
        `,
        variant: "secondary",
}